const openInNewTab = (url, newTab) => {
    var win = window.open(url, '_blank');
    if (newTab) {
      win.focus();
    }
  };

  export default openInNewTab;
  